import { render, staticRenderFns } from "./EventDosirak.vue?vue&type=template&id=1efb426f&"
import script from "./EventDosirak.vue?vue&type=script&lang=js&"
export * from "./EventDosirak.vue?vue&type=script&lang=js&"
import style0 from "./EventDosirak.vue?vue&type=style&index=0&id=1efb426f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports